import { isChartV2MarkdownHref } from '../chart-v2-markdown-link/ChartV2MarkdownLink';
import { VisualizationTable } from '../use-visualization-store/useVisualizationStore';
import { renderAlfredChartNode } from './copyAlfredCharts';
import { renderChartV2Node } from './copyChartV2';
import { generateImageTag } from './generateImageTag';
import { generateTableTag } from './generateTableTag';
import { htmlNodes } from './htmlNodes';
import { patterns } from './regex';

const getVisualizationIds = (text: string) => {
  return Array.from(text.matchAll(patterns.linkWithTitle), match => match[2]);
};

interface ReplaceVisualizationLinksArgs {
  originalContent: string;
  charts: Record<string, HTMLDivElement>;
  tables: Record<string, VisualizationTable>;
}

export const replaceVisualizationLinks = async ({
  originalContent,
  charts,
  tables,
}: ReplaceVisualizationLinksArgs) => {
  let result = originalContent;

  const visualizationIds = getVisualizationIds(originalContent);

  for (const id of visualizationIds) {
    // find the link, e.g. [xxxx](id "apache-line")
    const dynamicPattern = patterns.linkWithId(id);

    if (charts[id]) {
      const chartNode = charts[id];
      const hasCanvas = chartNode.querySelector('canvas') !== null;
      let chartTag: string | null;

      if (isChartV2MarkdownHref(id)) {
        chartTag = await renderChartV2Node(chartNode).catch(() => null);
      } else if (hasCanvas) {
        chartTag = generateImageTag(chartNode);
      } else {
        chartTag = await renderAlfredChartNode(chartNode).catch(() => null);
      }

      const tag = chartTag ?? '';
      result = result.replace(
        dynamicPattern,
        (_m, title) => `${htmlNodes.span(title)}${tag}`
      );
    }

    if (tables[id]) {
      const tableData = generateTableTag(tables[id]);
      result = result.replace(
        dynamicPattern,
        (_m, title) => `${htmlNodes.span(title)}${tableData}`
      );
    }
  }

  return result;
};
